module.exports = [
    {
        key: '',
        name: 'Escritorio',
        icon: 'laptop',
        clickable: true
    }, {
        key: 'hotels',
        name: 'Hoteles / Empresas',
        icon: 'hotel',
    }, {
        key: 'all_users',
        name: 'Usuarios',
        icon: 'male',
        child: [
            {
                key: 'list-managers',
                name: 'Gerentes',
                icon: 'circle'
            },
            {
                key: 'list-receptionists',
                name: 'Recepcionistas',
                icon: 'circle'
            },
            {
                key: 'list-users',
                name: 'Administradores',
                icon: 'circle'
            }
        ]
    }, {
        key: 'clients',
        name: 'Clientes',
        icon: 'users'
    }, {
        key: 'employees',
        name: 'Empleados',
        icon: 'male',
    }, {
        key: 'catalogs',
        name: 'Catálogos',
        icon: 'book',
        child: [
            {
                key: 'expenses_type',
                name: 'Movimientos',
                icon: 'circle'
            },
            {
                key: 'payments_type',
                name: 'Tipo de pagos',
                icon: 'circle'
            },
            /*{
                key: 'adons_type',
                name: 'Servicios adicionales',
                icon: 'circle'
            }*/
        ]
    }, {
        key: 'invoices',
        name: 'Facturas',
        icon: 'file-invoice-dollar',
        child: [
            {
                key: 'list-invoices',
                name: 'Todas las facturas',
                icon: 'circle'
            },
            {
                key: 'new-invoice',
                name: 'Solicitar factura',
                icon: 'circle'
            }
        ]
    }, /*{
        key: 'adons/list-adons',
        name: 'Servicios Adicionales',
        icon: 'cart-plus'
    },*/ {
        key: 'conta/hotel',
        name: 'Hotel Contabilidad',
        icon: 'chart-line',
        clickable: true
    }, {
        key: 'conta/trie',
        name: 'TRIE Contabilidad',
        icon: 'chart-pie',
        clickable: true
    }, {
        key: 'config',
        name: 'Configuración',
        icon: 'cogs',
        clickable: true
    },
]


// WEBPACK FOOTER //
// ./src/utils/menu.js